import { useCallback } from 'react';
import { TenantFeatures } from '@/features/auth/enums';
import useFeatureCheck from '@/features/auth/hooks/useFeatureCheck';

export type AccessGrantedArgs = {
  feature?: TenantFeatures;
};

export type AccessGranted = (args: AccessGrantedArgs) => boolean;

export interface UseAuthorizationT {
  isAccessGranted: AccessGranted;
}

/**
 * Auth check hook. Today only supports tenant features; the shape mirrors
 * goDash's so future dimensions (permissions, etc.) can slot in without
 * changing call sites.
 */
const useAuthorization = (): UseAuthorizationT => {
  const hasFeature = useFeatureCheck();

  const isAccessGranted = useCallback<AccessGranted>(
    ({ feature }) => {
      if (!feature) return true;
      return hasFeature(feature);
    },
    [hasFeature],
  );

  return { isAccessGranted };
};

export default useAuthorization;
